import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CModal from '@/components/CModal.vue';
import CSelect, { type CSelectItem, valueReducer } from '@/components/shared/CSelect';
import type { TeamUser } from '@/typings/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchTeamModal',
  props: {
    value: { type: Boolean },
    usernames: null
  },
  emits: ["input", "switch"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', value: boolean): void;
    (e: 'switch', username: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
    usernames?: TeamUser[];
};





const selectedUsername = ref<string>();

const isOpen = computed({
    get: () => props.value,
    set: (value: boolean) => emit('input', value)
});

const options = computed<CSelectItem[]>(() =>
    (props.usernames || [])
        .map((user) => ({
            value: user.ParentUsername || user.Username,
            label: user.ParentUsername
                ? `${user.Name || user.Username} (${user.ParentUsername})`
                : user.Name || user.Username || ''
        }))
        .sort((a, b) => a.label?.localeCompare(b.label, undefined, { sensitivity: 'base' }))
);

watch(
    () => props.value,
    (isVisible) => {
        if (isVisible) {
            selectedUsername.value = undefined;
        }
    }
);

const onSwitch = () => {
    if (selectedUsername.value) {
        emit('switch', selectedUsername.value);
    }
};

return { __sfc: true,props, emit, selectedUsername, isOpen, options, onSwitch, CModal, CSelect, valueReducer }
}

})